import {useDebugValue} from 'react';

import classNames from 'classnames';

const classNamespace = 'search-form';
const fieldsClassName = `${classNamespace}__fields`;
const summaryFieldsClassName = `${classNamespace}__summary-fields`;

function useComponent() {
    const className = classNames(fieldsClassName, summaryFieldsClassName);

    const result = {
        className,
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
